import axios from "axios";

const buscarConfigCliente = async (alias) => {
  let config = null;
  let http = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL.replace("[#cliente#]", alias),
    headers: {
      Accept: "application/json",
      "Content-Type": "applicattion/json;",
    },
  });

  try {
    let response = await http.get(`cfg/cliente/${alias}`);

    config = response.data.resultado.dados;
  } catch (error) {
    localStorage.clear();
    if (error?.response?.status == 404) {
      config = {
        clienteId: alias,
        ativo: false,
        manutencao: null,
        motivo: `Cliente ou alias '${alias}' não encontrado`,
      };
    } else if (error?.response?.status) {
      config = {
        clienteId: alias,
        ativo: false,
        manutencao: null,
        motivo: `Erro servidor. http code: ${error?.response?.status}`,
      };
    } else {
      config = {
        clienteId: alias,
        ativo: false,
        manutencao: null,
        motivo: `Erro desconhecido. erro: ${error?.message}`,
      };
    }
  }

  return config;
};

const ClienteConfigService = {
  config: null,
  getConfigCliente: async (alias) => {
    if (ClienteConfigService.config == null) {
      ClienteConfigService.config = await buscarConfigCliente(alias);
    }

    if (ClienteConfigService.config == null) {
      window.location.replace("/inativo.html");
    }

    if (!ClienteConfigService.config.ativo) {
      if (ClienteConfigService.config.motivo) {
        window.location.replace(
          "/inativo.html?motivo=" + ClienteConfigService.config.motivo
        );
        return;
      }

      window.location.replace("/inativo.html");
    }

    if (ClienteConfigService.config.manutencao.ativa) {
      window.location.replace(
        "/manutencao.html?motivo=" +
          ClienteConfigService.config.manutencao.motivo +
          "&data=" +
          ClienteConfigService.config.manutencao.previsao
      );
    }

    return ClienteConfigService.config;
  },
};

export default ClienteConfigService;
